module.exports = __webpack_public_path__ + "img/PT916.0717ce4e.png";